import { Loader2 } from 'lucide-react'

type Props = {
  readonly message?: string
}

export function LoadingSpinner({ message = 'Loading...' }: Props) {
  return (
    <div className='flex min-h-[400px] items-center justify-center'>
      <div className='text-center'>
        <Loader2 className='mx-auto mb-4 h-8 w-8 animate-spin' />
        <p className='text-gray-600'>{message}</p>
      </div>
    </div>
  )
}
